export default "__VITE_ASSET__b9f938ac__"